import rootActions from "../rootActions";

class customerAddressActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default customerAddressActions;
